export default __webpack_public_path__ + "static/media/beauty.a46da976.jpg";